import { GameMode } from '../types';
import type { ModeDescription } from './types';

export const INFINITE_TIMED_MODE: ModeDescription = {
  mode: GameMode.INFINITE_TIMED,
  title: 'Speed Run',
  description: 'Race to 100% completion. Wrong answers are ignored.',
  icon: '⏱️',
};
